import { useEffect, useState } from "react";
import { Flame } from "lucide-react";

const SECTIONS = [
  { id: "about", label: "01 / Thesis" },
  { id: "findings", label: "02 / Findings" },
  { id: "explorer", label: "03 / Explorer" },
  { id: "how", label: "04 / Protocol" },
  { id: "install", label: "05 / Install" },
  { id: "updates", label: "06 / Updates" },
  { id: "resources", label: "07 / Resources" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState("");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
      const y = window.scrollY + 120;
      for (let i = SECTIONS.length - 1; i >= 0; i--) {
        const el = document.getElementById(SECTIONS[i].id);
        if (el && el.offsetTop <= y) {
          setActive(SECTIONS[i].id);
          return;
        }
      }
      setActive("");
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="main-nav"
      className={
        "fixed top-0 left-0 right-0 z-50 transition-all duration-300 " +
        (scrolled
          ? "backdrop-blur-md bg-[#0A0A0A]/85 border-b border-white/10"
          : "bg-transparent border-b border-transparent")
      }
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between gap-8">
        <a
          href="#top"
          data-testid="nav-brand"
          className="flex items-center gap-3 group shrink-0 lg:mr-6"
        >
          <span className="w-8 h-8 border border-[#FF4D00]/60 flex items-center justify-center text-[#FF4D00] group-hover:bg-[#FF4D00]/10 transition-colors">
            <Flame className="w-4 h-4 flicker" />
          </span>
          <span className="font-mono text-[11px] tracking-[0.32em] text-neutral-200">
            PROMETHEUS<span className="text-[#FF4D00]">·</span>EBM
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-5 xl:gap-6 flex-1 justify-center">
          {SECTIONS.map((s) => {
            const [num, label] = s.label.split(" / ");
            return (
              <a
                key={s.id}
                href={"#" + s.id}
                data-testid={`nav-link-${s.id}`}
                className={
                  "text-[10px] tracking-[0.24em] uppercase transition-colors font-mono flex items-baseline gap-1.5 " +
                  (active === s.id
                    ? "text-[#FF4D00]"
                    : "text-neutral-500 hover:text-neutral-200")
                }
              >
                <span className="text-neutral-700">{num}</span>
                <span>{label}</span>
              </a>
            );
          })}
        </div>

        <a
          href="https://pypi.org/project/prometheus-ebm/"
          target="_blank"
          rel="noreferrer"
          data-testid="nav-pypi-link"
          className="hidden sm:inline-flex items-center gap-2 border border-[#FF4D00]/60 text-[#FF4D00] text-[10px] tracking-[0.22em] uppercase px-3 py-2 hover:bg-[#FF4D00]/10 transition-colors shrink-0"
        >
          pip install
        </a>
      </div>
    </nav>
  );
}
